/**
 * 上传文件 button
 */
import React, { useContext, useEffect, useState, useMemo, useCallback, ReactChild } from "react";
import { Button, Upload, message } from "antd";

import { UploadControlCenterInstance, joyspaceKey } from "@/components/UploadBox/UploadControl";
import {
  groupJoyspaceKey,
  GroupUploadControlCenterInstance
} from "@/components/Joyspace/components/GroupUploadPanel/UploadController";
import { RcFile } from "antd/lib/upload/interface";
import { UploadFile } from "./types";
// import isFunction from 'lodash/isFunction';
// import './index.less';
import context, { useTranslation } from "../../context";
import { useHistory } from "react-router-dom";
import GlobalContext, { GlobalContextConfig } from "@/context/GlobalContext";
import events from "../../context/events";
import { notUseJoySpaceOffline } from "../../util";
import { debounce } from "lodash";
import { analysisLog } from "@/utils/logAnalytics";

export interface OwnProps {
  className?: string;
  fromPage?: string;
  categoryId?: string;
  onUploadFile?: (result: any) => void;
  teamId?: string;
  folderId?: string;
  spaceId?: string;
  projectId?: string;
  archive?: boolean;
  gid?: string;
  from?: string;
  children?: ReactChild;
}

export interface OwnState {
  ProgressHandler: null;
}

type IProps = Readonly<OwnProps>;

function UploadButton(props: IProps) {
  const lang = useTranslation();
  const {
    fromPage,
    onUploadFile,
    archive = false,
    gid,
    folderId,
    spaceId,
    projectId,
    from = ""
  } = props;
  const uploadControlInstance = gid
    ? GroupUploadControlCenterInstance.get(groupJoyspaceKey) ||
      GroupUploadControlCenterInstance.register(groupJoyspaceKey, true, gid)
    : UploadControlCenterInstance.get(joyspaceKey);
  const [disabled, setDisabled] = useState(false);
  const { appRuntimeEnv, onLine } = useContext<GlobalContextConfig>(GlobalContext);

  useMemo(() => {
    if (notUseJoySpaceOffline()) {
      return;
    }
    setDisabled(!onLine);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onLine]);
  const beforeUpload = async (_file: RcFile, _fileList: RcFile[]) => {
    const file = _file as UploadFile;
    // console.log(folderId, spaceId, categoryId, projectId, 'beforeUpload===>');
    Object.assign(file, {
      folderId,
      spaceId,
      // categoryId,
      projectId
    });
    const { fileService, joyspaceWpsTarget } = appRuntimeEnv;
    if (!uploadControlInstance) {
      console.log("joyspaceuploadControlInstance获取出错");
      return;
    }
    // uploadControlInstance.once(`${FILEUPLOADER_UPFILE_END}:${file.uid}`, uploadListener);
    try {
      analysisLog(
        "xtbg_jzb_joyspace_home_1676548210761",
        "38",
        from || "",
        file.name,
        spaceId || "",
        file.type,
        "click"
      );
      await uploadControlInstance.addFile(file, fileService, { joyspaceWpsTarget }, gid);
    } catch (e) {
      console.error(e);
      // if ((e as any).message === 'zeroSize') {
      //     message.warn(lang('myspace.noZeroSize'));
      // }
    }
  };

  // beforeUpload 接收的fileList是当前用户选择的文件

  const uploadProps = {
    multiple: true, // 支持多文件上传 IE10+
    name: "files", // 传到后台的文件参数名称
    showUploadList: false, // 是否展示上传文件列表
    onChange: () => {},
    beforeUpload,
    customRequest: (_param: any) => {}
  };
  return (
    <div className="ant-upload-custom">
      {archive || disabled ? (
        <Button
          type="default"
          disabled={archive || disabled}
          clstag="pageclick|keycount|focus_joyspace_01_1615797631505|4"
        >
          {props.children}
          {lang("myspace.upload")}
        </Button>
      ) : (
        <Upload {...uploadProps}>
          <Button
            type="default"
            disabled={archive || disabled}
            clstag="pageclick|keycount|focus_joyspace_01_1615797631505|4"
          >
            {props.children}
            {lang("myspace.uploadFile")}
          </Button>
        </Upload>
      )}
    </div>
  );
}

export default UploadButton;
